import {MainNavDefinition} from './mainNav'

export {MainNavDefinition}
